export const MULTIPLIER = 10 ** 9;

const feeFormatter = new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 9,
    minimumFractionDigits: 0,
});

const currencyFormatter = new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
});

const currencyFormatterRound = new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 0,
});

export const formatTons = function formatNanoTonsLimitNumberLength(value, decimals = 9, round = false, floatSplit = false) {
    const valueMultiplier = Number.isInteger(decimals)
        ? Math.pow(10, decimals) /* eslint prefer-exponentiation-operator: "off", no-restricted-properties: "off" */
        : MULTIPLIER;

    const currency = currencyFormatter.format(value / valueMultiplier);
    const fee = feeFormatter.format(value / valueMultiplier);

    const formattedCurrency = currency.replace(/,/g, '.');
    const formattedFee = fee.replace(/,/g, '.');

    if (floatSplit) {
        const [intPart, fracPart] = round
            ? formattedCurrency.split('.')
            : formattedFee.split('.');

        return {
            int: intPart,
            frac: fracPart ? '.' + fracPart : '',
        };
    }

    return round
        ? formattedCurrency
        : formattedFee;

    // return round
    //     ? currencyFormatter.format(value / valueMultiplier)
    //     : feeFormatter.format(value / valueMultiplier);
};

export const formatFiat = function formatFiatValue(value, round = false) {
    const formatter = round ? currencyFormatterRound : currencyFormatter;
    return formatter.format(value).replace(/,/g, '.');
};

export const formatRoundNumber = function formatRoundNumberValue(value) {
    return currencyFormatterRound.format(value).replace(/,/g, '.');
};

export const formatDate = (dateValue) => {
    const date = new Date(Number(dateValue));
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
};

// export const formatValidatorDate = (timestamp, locale) => {
//     const date = new Date(timestamp * 1000);

//     const dateFormat = new Intl.DateTimeFormat(locale, {
//         day: 'numeric',
//         month: 'short',
//         hour: '2-digit',
//         minute: '2-digit',
//     });

//     const formattedDate = dateFormat.format(date);

//     return `${formattedDate}`;
// };

export const formatValidatorDate = (timestamp, locale) => {
    const date = new Date(timestamp * 1000);
    const now = new Date();

    const currentYear = now.getFullYear();
    const dateYear = date.getFullYear();

    const dateFormat = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        year: currentYear === dateYear ? undefined : 'numeric',
    });

    let formattedDate = dateFormat.format(date);

    if (locale.startsWith('ru')) {
        formattedDate = formattedDate.replace(/(\s[а-яё]+)\./i, '$1');
    }

    return formattedDate;
};

// export const getCurrencyFormatter = (locale, currency) => new Intl.NumberFormat(locale, { style: 'currency', currency });

export const getCurrencyFormatter = (locale, currency) => {
    // narrowSymbol: «₽» in every locale, the EN one would otherwise print «RUB»
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' });
    const parts = formatter.formatToParts(0);
    const currencySymbol = parts.find(part => part.type === 'currency')?.value || '';

    return formattedValue => `${formattedValue} ${currencySymbol}`;
};

export const formatFee = formatTons;

export const getDaysAgoTimestamp = (daysAgo) => {
    const now = Math.floor(Date.now() / 1000);
    return now - (daysAgo * 86400);
};

export const shrinkAddress = (address) => {
    const ellipsis = '...';

    const visibleTextLength = Math.max(0, 14 - ellipsis.length);

    const partLength = Math.floor(visibleTextLength / 2);
    return address.slice(0, partLength) + ellipsis + address.slice(-partLength);
};

export const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatDecimals = (value, decimals) => {
    const formattedNumber = value / Math.pow(10, decimals);

    return parseFloat(formattedNumber.toFixed(decimals));
};

export const formatSwap = (value, decimals) => {
    const price = formatDecimals(value, Number.isInteger(decimals) ? decimals : 9);

    const numericPrice = parseFloat(price);

    let stringValue;

    if (numericPrice >= 0.1) {
        stringValue = numericPrice.toFixed(2);
    } else if (numericPrice > 0.01) {
        stringValue = numericPrice.toFixed(2);
    } else if (numericPrice > 0) {
        stringValue = numericPrice.toString();

        if (stringValue.includes('e-')) {
            const parts = stringValue.split('e-');
            const base = parts[0].replace('.', '');
            const exponent = parseInt(parts[1], 10);

            stringValue = '0.' + '0'.repeat(exponent - 1) + base;
        }

        const regex = /0\.(0*)([1-9])/;
        const match = stringValue.match(regex);
        if (match) {
            const leadingZeros = match[1];
            const firstNonZero = match[2];
            stringValue = `0.${leadingZeros}${firstNonZero}`;
        }
    } else {
        return '0.00';
    }

    const parts = stringValue.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    const result = parts.join('.');

    return result.endsWith('.00') ? result.slice(0, -3) : result;

    // return parts.join('.');
};

export const formattedPrice = (value) => {
    const numericPrice = parseFloat(value);

    let stringValue;

    if (numericPrice >= 0.1) {
        stringValue = numericPrice.toFixed(2);
    } else if (numericPrice > 0.01) {
        stringValue = numericPrice.toFixed(2);
    } else if (numericPrice > 0) {
        stringValue = numericPrice.toString();

        if (stringValue.includes('e-')) {
            const parts = stringValue.split('e-');
            const base = parts[0].replace('.', '');
            const exponent = parseInt(parts[1], 10);

            stringValue = '0.' + '0'.repeat(exponent - 1) + base;
        }

        const regex = /0\.(0*)([1-9])/;
        const match = stringValue.match(regex);
        if (match) {
            const leadingZeros = match[1];
            const firstNonZero = match[2];
            stringValue = `0.${leadingZeros}${firstNonZero}`;
        }
    } else {
        return '0.00';
    }

    const parts = stringValue.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return parts.join('.');
};

export const formattedPriceChart = (value) => {
    const numericPrice = parseFloat(value);

    let stringValue;

    if (numericPrice >= 10000) {
        return currencyFormatterRound.format(value);
    }

    if (numericPrice >= 1) {
        stringValue = numericPrice.toFixed(2);
    } else if (numericPrice > 0) {
        stringValue = numericPrice.toString();

        if (stringValue.includes('e-')) {
            const parts = stringValue.split('e-');
            const base = parts[0].replace('.', '');
            const exponent = parseInt(parts[1], 10);

            stringValue = '0.' + '0'.repeat(exponent - 1) + base;
        }

        const regex = /0\.(0*)([1-9][0-9]+)/;
        const match = stringValue.match(regex);
        if (match) {
            const leadingZeros = match[1];
            const firstNonZero = match[2].slice(0, 3);
            stringValue = `0.${leadingZeros}${firstNonZero}`;
        } else {
            stringValue = '0.' + stringValue.split('.')[1];
        }
    } else {
        return '0.00';
    }

    const parts = stringValue.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return parts.join('.');
};

export const truncateTicker = (value, limit = 10) => {
    if (value && value.length > limit) return value.slice(0, limit - 2) + '...';
    return value;
};

// Jetton masters that may legitimately carry a native coin or USDT ticker.
// A jetton that wears one of these tickers from any other address is an impostor,
// and the transaction list shows its (shortened) address in place of the ticker.
const GENUINE_TICKER_ADDRESSES = {
    USDT: [
        'EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs',
    ],
    // The native coin is never a jetton, so the only addresses allowed to wear
    // its tickers are the DEX wrappers (STON.fi pTON v1 / v2):
    TON: [
        'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez',
        'EQBnGWMCf3-FZZq1W4IWcWiGAc3PHuZ0_H-7sad2oY00o83S',
    ],
    GRAM: [
        'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez',
        'EQBnGWMCf3-FZZq1W4IWcWiGAc3PHuZ0_H-7sad2oY00o83S',
    ],
};

export const shortenAddress = (address) => {
    if (!address) return address;
    return address.slice(0, 3) + '…' + address.slice(-3);
};

/**
 * @param  {String} symbol
 * @param  {String} address  jetton master address
 * @return {Boolean}  true if the jetton borrows a ticker it has no right to
 */
export const isImpersonatingTicker = (symbol, address) => {
    if (!symbol || !address) return false;

    const normalized = symbol.trim().toUpperCase().replace(/₮/g, 'T');
    const genuine = GENUINE_TICKER_ADDRESSES[normalized];

    return genuine !== undefined && !genuine.includes(address);
};

/**
 * Ticker to show in the transaction list: the jetton's own symbol (truncated,
 * since metadata is arbitrary and may hold a whole script instead of a ticker),
 * or its shortened address when the symbol is a well-known impostor.
 *
 * @param  {String} symbol
 * @param  {String} address  jetton master address
 * @return {String}
 */
export const displayTicker = (symbol, address) => {
    if (isImpersonatingTicker(symbol, address)) {
        return shortenAddress(address);
    }

    return truncateTicker(symbol);
};

// navigator.clipboard exists only on https, so on http this copies through a hidden textarea:
export const copyTextFallback = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
};
